import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const PodcastDetail: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <BooksDetail
            library_category={ELibraryCategory.PODCAST}
            library_head_name={t("พอดแคสต์")}
            library_head_pathname={routeName.e_library.podcast}
            library_head_list_path={routeName.e_library.podcast_list}
        />
    )
}

export default PodcastDetail